// extracted by mini-css-extract-plugin
export default {"ContactUs":"ContactUs_ContactUs__0HTSf","Info":"ContactUs_Info__Cv1rv","Form":"ContactUs_Form__T7ChP"};